// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const addYoutubeApiScript = function () {
  const tag = document.createElement('script');
  tag.id = 'youtube-adobe-video';
  tag.src = 'https://www.youtube.com/iframe_api';
  const firstScriptTag = document.getElementsByTagName('script')[0];
  return firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
};

if ($('#istock-adobe-ytplayer').length > 0) {
  addYoutubeApiScript();

  let firstTimePlay = false;

  const onPlayerStateChange = function (event) {
    if (event.data === 1 && !firstTimePlay) {
      // Player starts playing
      $(document).trigger('track.adobePlugin.videoStart');
      return (firstTimePlay = true);
    }
  };

  // This needs to be global to be picked up by the youtube api, so we attach it to window
  window.onYouTubeIframeAPIReady = function () {
    let player;
    return (player = new YT.Player('istock-adobe-ytplayer', {
      events: { onStateChange: onPlayerStateChange },
    }));
  };
}

$('#download-mac').click(() =>
  $(document).trigger('track.adobePlugin.macDownload')
);

$('#download-pc').click(() =>
  $(document).trigger('track.adobePlugin.pcDownload')
);

$('#app-store-badge').click(() =>
  $(document).trigger('track.adobePlugin.iosAppDownload')
);

$('#google-play-badge').click(() =>
  $(document).trigger('track.adobePlugin.googlePlayDownload')
);
